<template>
  <div id="source">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style>
#source{
  height: 100%;
}
</style>